import { FC } from 'react';
import { Control, Controller, FieldErrors } from 'react-hook-form';
import { VisionAIGenerateFormData } from './vision-ai-generate.schema';

interface VisionAIGenerateFormProps {
  control: Control<VisionAIGenerateFormData>;
  errors: FieldErrors<VisionAIGenerateFormData>;
  isLoading: boolean;
}

const VisionAIGenerateForm: FC<VisionAIGenerateFormProps> = ({ control, errors, isLoading }) => {
  return (
    <>
      <div>
        <label htmlFor="future_aspiration" className="block text-sm font-medium text-gray-700 mb-2">
          Future Aspiration <span className="text-gray-400">(Optional)</span>
        </label>
        <Controller
          name="future_aspiration"
          control={control}
          render={({ field }) => (
            <textarea
              {...field}
              id="future_aspiration"
              rows={4}
              className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 ${
                errors.future_aspiration ? 'border-red-500' : 'border-gray-300'
              }`}
              placeholder="Menjadi pemimpin pasar di Asia Tenggara untuk solusi energi terbarukan..."
              disabled={isLoading}
            />
          )}
        />
        {errors.future_aspiration && <p className="text-sm text-red-500 mt-1">{errors.future_aspiration.message}</p>}
        <p className="text-xs text-gray-500 mt-1">
          Menjelaskan keinginan yang akan dicapai 5-10 tahun ke depan. Input harus berupa kalimat yang jelas dan
          inspiratif.
        </p>
      </div>

      <div>
        <label htmlFor="target_achievement" className="block text-sm font-medium text-gray-700 mb-2">
          Target Achievement <span className="text-gray-400">(Optional)</span>
        </label>
        <Controller
          name="target_achievement"
          control={control}
          render={({ field }) => (
            <textarea
              {...field}
              id="target_achievement"
              rows={4}
              className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 ${
                errors.target_achievement ? 'border-red-500' : 'border-gray-300'
              }`}
              placeholder="Mencapai pendapatan tahunan sebesar $100 juta..."
              disabled={isLoading}
            />
          )}
        />
        {errors.target_achievement && <p className="text-sm text-red-500 mt-1">{errors.target_achievement.message}</p>}
        <p className="text-xs text-gray-500 mt-1">
          Target yang dicapai (misalnya metrik angka). Input harus terstruktur (measurable). Contoh: Mencapai pendapatan
          tahunan sebesar $100 juta, memiliki 1 juta pelanggan rumah tangga yang menggunakan produk kami, dan memperluas
          operasional ke tiga negara baru.
        </p>
      </div>

      <div>
        <label htmlFor="desired_impact" className="block text-sm font-medium text-gray-700 mb-2">
          Desired Impact <span className="text-gray-400">(Optional)</span>
        </label>
        <Controller
          name="desired_impact"
          control={control}
          render={({ field }) => (
            <textarea
              {...field}
              id="desired_impact"
              rows={4}
              className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 ${
                errors.desired_impact ? 'border-red-500' : 'border-gray-300'
              }`}
              placeholder="Menciptakan lapangan kerja hijau untuk 10.000 orang..."
              disabled={isLoading}
            />
          )}
        />
        {errors.desired_impact && <p className="text-sm text-red-500 mt-1">{errors.desired_impact.message}</p>}
        <p className="text-xs text-gray-500 mt-1">
          Dampak luas yang ingin diciptakan perusahaan terhadap masyarakat, lingkungan, atau industri. Contoh:
          Menciptakan lapangan kerja hijau untuk 10.000 orang, mengurangi jejak karbon pelanggan sebesar 20%, dan
          menginspirasi industri lain untuk mengadopsi praktik bisnis yang berkelanjutan.
        </p>
      </div>

      <div>
        <label htmlFor="timeline" className="block text-sm font-medium text-gray-700 mb-2">
          Timeline <span className="text-gray-400">(Optional)</span>
        </label>
        <Controller
          name="timeline"
          control={control}
          render={({ field }) => (
            <input
              {...field}
              type="text"
              id="timeline"
              className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 ${
                errors.timeline ? 'border-red-500' : 'border-gray-300'
              }`}
              placeholder="10"
              disabled={isLoading}
            />
          )}
        />
        {errors.timeline && <p className="text-sm text-red-500 mt-1">{errors.timeline.message}</p>}
        <p className="text-xs text-gray-500 mt-1">
          Jangka waktu spesifik untuk mencapai target (dinyatakan dalam tahun). Hanya angka yang diperbolehkan.
        </p>
      </div>
    </>
  );
};

export default VisionAIGenerateForm;
